export default "__VITE_ASSET__55561206__"